const textFormatMixin = {
  methods: {
    truncateText(text, length) {
      if (!text) {
        return ''
      }
      if (text.length <= length) {
        return text
      }

      return `${text.substring(0, length)}...`
    },
    separateDateTime(dateTimeString) {
      // Callers use the result directly as `.date` / `.time`, so never return
      // null — an unparseable value must degrade to empty strings, not crash
      // the render.
      if (!dateTimeString) return { date: '', time: '' }

      // Expected server format: DD-MM-YYYY HH:MM
      const regex = /^(\d{2}-\d{2}-\d{4})\s(\d{2}:\d{2})$/;
      const match = dateTimeString.match(regex);
      if (match) {
        // match[1] will be the date part (e.g., "25-07-2025")
        // match[2] will be the time part (e.g., "13:35")
        return {
          date: match[1],
          time: match[2],
        }
      }

      // Fallback for other formats (e.g. an ISO string from an older offline
      // entry): parse and reformat to DD-MM-YYYY HH:MM.
      const parsed = new Date(dateTimeString)
      if (!Number.isNaN(parsed.getTime())) {
        const pad = n => String(n).padStart(2, '0')

        return {
          date: `${pad(parsed.getDate())}-${pad(parsed.getMonth() + 1)}-${parsed.getFullYear()}`,
          time: `${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`,
        }
      }

      return { date: '', time: '' }
    },
  },
}

export default textFormatMixin
